
import { defineComponent } from 'vue'
import store from '@/store/index'
import { ButtonGroup, IconButton, Card, UiNumberpad } from '@/ui/index'
import { EmployeeController, PresenceController, WorkbreakController, TimeEntryController,  UpdateController, WorkstationController, ProjectController, ClientController, WorkController } from '@/controller/'
import { User, Presence, Workbreak, Employee, TimeEntry, Workstation, ObjectStorage, Project, Client, Work } from '@/model'
import { DateTimeUtils } from "@/utils/"
import { TimeEntryList } from '@/components'
import { ComAddTimeEntry } from './components'

export default defineComponent({
    name: "Workspace",
    components: { TimeEntryList, Card, ButtonGroup, IconButton, ComAddTimeEntry, UiNumberpad },
    data(){
        return {
            store,
            activeDay: 0,
            today: 0,
            form: {
                eCode: ''
            },
            employees: [] as Array<Employee>,
            workstation: {} as Workstation | null,
            employee: {} as Employee | null,
            activePresence: {} as Presence | null,
            presences: [] as Presence[],
            activeBreak: {} as Workbreak | null,
            workBreaks: [] as Workbreak[],
            workspaceTimeEntries: [] as Array<TimeEntry>,
            timeEntries: [] as Array<TimeEntry>,
            activeTimeEntry: {} as TimeEntry | null,
            lastTimeEntries: [] as Array<TimeEntry>,
            projects: [] as Array<Project>,
            clients: [] as Array<Client>,
            works: [] as Array<Work>,
            activeTimeTracked: '00:00 h',
            nfcChipId: '',
            closeTimeouts: [] as Array<number>,
            closeAfterSeconds: 5,
            closeAfterInteractionSeconds: 10,
            closeAfterSuccess: 1.5,
            resetAfterError: 2,
            presenceLoaded: false,
            breakLoaded: false,
            timeEntriesLoaded: false,
            timeoutLastSet: new Date(),
            daySum: 0,
            resetSwipe: false,
            showNewTimeEntry: false,
            actionSuccess: false,
            actionError: false,
            svg: {
                nfc: '<?xml version="1.0" encoding="UTF-8"?><svg id="all_objects" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3629 2969.85"><defs><style>.cls-1{fill:none;}</style></defs><circle cx="752.61" cy="944.65" r="70.53" transform="translate(-447.53 808.86) rotate(-45)"/><path d="M749.14,731.68c73.09,0,137.31,38.21,173.98,95.68,13.06,20.46,42.24,22.67,59.4,5.5l2-2c12.87-12.87,15.3-33.13,5.4-48.41-51.19-78.95-139.89-131.38-240.79-131.38-98.87,0-186.12,50.3-237.77,126.6-10.33,15.26-8,35.86,5.03,48.89l2.17,2.17c16.93,16.93,45.63,15.05,58.91-4.86,37.02-55.51,100.07-92.19,171.67-92.19Z"/><path d="M749.14,532.04c128.64,0,243.23,60.3,317.65,153.96,14.68,18.48,41.77,20.83,58.46,4.14l2.28-2.28c13.94-13.94,15.31-36.21,3.06-51.65-89.24-112.48-227.05-184.77-381.45-184.77-152.41,0-288.59,70.47-377.91,180.47-12.58,15.49-11.46,38.02,2.65,52.13l2.19,2.19c16.55,16.55,43.38,14.38,58.14-3.78,74.49-91.65,187.89-150.41,314.93-150.41Z"/><path class="cls-1" d="M2030.63,1563.82c22.94-66.08,73.36-119.08,138.32-145.42,112.13-45.43,243.26,2.86,305.38,112.16l44.51,78.3,42.6-166.97,7.65-29.97c1.18-4.65,1.75-9.3,2.09-13.92,2.49-33.03-15.52-64.42-45.25-78.75-4.76-2.3-9.81-4.17-15.14-5.53l-262.2-66.89-790.25-201.61-59.26-15.12-245.07-62.52c-6.66-1.69-13.38-2.5-19.95-2.5-36.05,0-68.95,24.33-78.28,60.8l-102.16,400.47-17.18,67.34-69.03,270.61c-5.3,20.79-2.13,42.5,8.91,61.11,11.04,18.63,28.59,31.8,49.36,37.1h0s1356.78,346.14,1356.78,346.14c6.87,1.73,13.7,2.23,20.46,2.18l-254.34-447.4c-34.45-60.56-40.99-133.32-17.96-199.59Z"/><path class="cls-1" d="M997.07,1010.89c9.29-36.47,32.35-67.19,64.9-86.52,32.52-19.3,70.58-24.83,107.01-15.52l251.38,64.13c22.12-67.88,34.23-140.23,34.23-215.38,0-384.32-312.66-696.99-696.99-696.99S60.61,373.28,60.61,757.6s312.66,696.99,696.99,696.99c44.23,0,87.45-4.32,129.41-12.24l110.06-431.46Z"/><path class="cls-1" d="M2652.57,1844.07c7.4,13.02,19.41,22.37,33.85,26.34,14.41,3.97,29.53,2.1,42.56-5.31l10-5.71c12.52-7.1,21.51-18.64,25.33-32.49,3.79-13.86,1.98-28.37-5.12-40.87l-154.45-268.78-42.73,167.53,90.56,159.3Z"/><path d="M3264.18,2949.54c5.53-15.56-2.43-32.67-17.91-38.41l-520.78-192.97c-39.89-14.46-81.15-29.4-144.56-140.95l-191.28-336.48-14.99-26.35-15.4-27.1-257.98-453.81c-25.81-45.4-30.69-99.98-13.41-149.76,17.49-50.31,54.36-89.08,103.87-109.14,21.04-8.54,43-12.59,64.87-12.59,65.34,0,129.68,36.33,165.04,98.53l75.6,132.98,21.59,37.97,21.57,37.95,59.48,104.62c15.39,27.09,40.4,46.57,70.43,54.82,30.13,8.26,61.53,4.35,88.63-11.07l10-5.7c26.58-15.11,45.66-39.66,53.77-69.12,8.11-29.46,4.26-60.33-10.92-87.01l-185.57-322.96,1.55-6.11c19.27-75.54-26.52-152.66-102.04-171.91l-193.66-49.4c43.67-71.48,132.95-105.04,214.67-75.48l411.09,149c133.56,48.03,138.91,57.46,173.8,118.79l439.72,773.51c8.64,15.19,28.04,20.41,43.11,11.54.06-.04.12-.07.19-.11,13.68-8.02,18.37-25.56,10.54-39.34l-440.87-775.54c-44.21-77.77-61.82-94.03-205.88-145.84l-411.03-148.97c-115.03-41.76-241.79,10.42-296.07,116.95l-792.1-202.07c23.28-72.7,35.94-150.09,35.94-230.41C1515.19,339.85,1175.34,0,757.6,0,340.07,0,0,340.07,0,757.6c0,417.74,339.85,757.59,757.6,757.59,38.4,0,76.11-2.92,112.99-8.46l-61.88,242.56c-9.32,36.47-3.82,74.49,15.51,107.04,19.3,32.54,50.04,55.59,86.5,64.9h0s1356.78,346.11,1356.78,346.11c11.57,2.96,23.29,4.42,34.95,4.42,11.07,0,22.03-1.55,32.79-4.15l193.01,339.53c74.43,130.97,131.07,151.49,176.59,167.99l520.39,192.81c15.78,5.85,33.34-2.35,38.9-18.23.02-.05.04-.11.07-.18ZM2604.74,1517.25l154.45,268.78c7.1,12.5,8.91,27,5.12,40.87-3.82,13.85-12.81,25.39-25.33,32.49l-10,5.71c-13.02,7.41-28.14,9.28-42.56,5.31-14.44-3.97-26.46-13.32-33.85-26.34l-90.56-159.3,42.73-167.53ZM757.6,1454.59c-384.33,0-696.99-312.67-696.99-696.99S373.26,60.61,757.6,60.61s696.99,312.67,696.99,696.99c0,75.16-12.1,147.51-34.23,215.38l-251.38-64.13c-36.43-9.31-74.49-3.77-107.01,15.52-32.55,19.32-55.61,50.04-64.9,86.52l-110.06,431.46c-41.96,7.91-85.19,12.24-129.41,12.24ZM2282.47,2208.63l-1356.78-346.13h0c-20.77-5.31-38.32-18.48-49.36-37.11-11.04-18.61-14.2-40.32-8.91-61.11l69.03-270.61,17.18-67.34,102.16-400.47c9.32-36.47,42.23-60.8,78.28-60.8,6.57,0,13.29.81,19.95,2.5l245.07,62.52,59.26,15.12,790.25,201.61,262.2,66.89c5.33,1.36,10.37,3.23,15.14,5.53,29.73,14.33,47.73,45.72,45.25,78.75-.34,4.63-.9,9.28-2.09,13.92l-7.65,29.97-42.6,166.97-44.51-78.3c-62.12-109.3-193.25-157.59-305.38-112.16-64.96,26.34-115.39,79.34-138.32,145.42-23.02,66.27-16.48,139.03,17.96,199.59l254.34,447.4c-6.76.05-13.6-.44-20.46-2.18Z"/></svg>',
                success: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" version="1.1" viewBox="0 0 16 18">  <g>        <circle cx="8" cy="9" r="7" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".9"/>        <polyline points="11.2 7.1 7.4 10.9 4.8 8.4" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".9"/>  </g></svg>',
                error: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" version="1.1" viewBox="0 0 16 18">  <g>        <line x1="8" y1="10.6" x2="8" y2="7.4" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".9"/>        <polygon points=".9 15.1 8 2.9 15.1 15.1 .9 15.1" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".9"/>        <line x1="8" y1="12.5" x2="8" y2="12.5" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".9"/>  </g></svg>'
            },
            icons: {
                workbreak: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" version="1.1" viewBox="0 0 16 18">  <g><line x1="2.8" y1="2.6" x2="2.8" y2="6.1" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>        <line x1="9.7" y1="2.6" x2="9.7" y2="6.1" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>        <line x1="6.3" y1=".9" x2="6.3" y2="6.1" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>        <path d="M11.3,14.5v-5.9s-10.2,0-10.2,0v5.9c0,1.4,1.2,2.6,2.6,2.6,0,0,5,0,5,0,1.4,0,2.6-1.2,2.6-2.6Z" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>        <path d="M11.7,14.2h.8c1.4,0,2.4-1.2,2.4-2.6v-1.4s-3.2,0-3.2,0" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>  </g></svg>',
                go: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" version="1.1" viewBox="0 0 16 18">  <g> <line x1="10.9" y1="9" x2="7.3" y2="9" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10"/>        <line x1="14.5" y1="9" x2="10.9" y2="9" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>        <polyline points="11.6 14.8 11.6 17 1.5 17 1.5 1 11.6 1 11.6 3.2" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>        <line x1="11.6" y1="6.1" x2="14.5" y2="9" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10"/>        <line x1="11.6" y1="11.9" x2="14.5" y2="9" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10"/>  </g></svg>',
                come: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" version="1.1" viewBox="0 0 16 18">  <g>    <g>      <line x1="5.1" y1="9" x2="1.5" y2="9" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10"/>      <polyline points="4.4 3.2 4.4 1 14.5 1 14.5 17 4.4 17 4.4 14.8" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>      <line x1="8.7" y1="9" x2="5.1" y2="9" fill="none" stroke="#1b1b1b" stroke-miterlimit="10"/>      <line x1="5.8" y1="6.1" x2="8.7" y2="9" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10"/>      <line x1="5.8" y1="11.9" x2="8.7" y2="9" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10"/>    </g>  </g></svg>',
                comego: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" version="1.1" viewBox="0 0 16 18">  <g>          <g>        <g>          <line x1="12.4" y1="6.5" x2="10.8" y2="6.5" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>          <line x1="14.6" y1="6.5" x2="12.4" y2="6.5" fill="none" stroke="#1b1b1b" stroke-miterlimit="10" stroke-width="1"/>          <polyline points="6.5 5 6.5 1.5 12.8 1.5 12.8 2.9" fill="none" stroke="#1b1b1b" stroke-miterlimit="10" stroke-width="1"/>          <polyline points="12.8 10.1 12.8 11.5 10.7 11.5" fill="none" stroke="#1b1b1b" stroke-miterlimit="10" stroke-width="1"/>          <line x1="12.8" y1="4.7" x2="14.6" y2="6.5" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>          <line x1="12.8" y1="8.3" x2="14.6" y2="6.5" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>        </g>        <g>          <line x1="3.6" y1="11.5" x2="1.4" y2="11.5" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>          <polyline points="3.2 7.9 3.2 6.5 9.5 6.5 9.5 16.5 3.2 16.5 3.2 15.1" fill="none" stroke="#1b1b1b" stroke-miterlimit="10" stroke-width="1"/>          <line x1="5.9" y1="11.5" x2="3.6" y2="11.5" fill="none" stroke="#1b1b1b" stroke-miterlimit="10" stroke-width="1"/>          <line x1="4.1" y1="9.7" x2="5.9" y2="11.5" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>          <line x1="4.1" y1="13.3" x2="5.9" y2="11.5" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>        </g>      </g>      </g></svg>',
                presence: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" version="1.1" viewBox="0 0 16 18">  <g>          <g>        <circle cx="8" cy="9" r="6.7" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".8"/>        <polyline points="8 5.4 8 9 10.4 9" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".8"/>      </g>      </g></svg>',
                worktime: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" version="1.1" viewBox="0 0 16 18">  <g>      <path d="M1.2,15.9c.9-.9,1.6-1.6,1.6-1.6-.5-1.3-.2-2.8.9-3.9,1.1-1.1,2.6-1.3,3.9-.9l-2.6,2.6.4,1.9,1.9.4,2.6-2.6c.5,1.3.2,2.8-.9,3.9-1.1,1.1-2.6,1.3-3.9.9,0,0-.2.2-.5.5" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".8"/>      <g>        <path d="M3,8.7c0-.4-.1-.8-.1-1.3,0-3.3,2.7-6,6-6s6,2.7,6,6-1.2,4.2-3.1,5.3" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".8"/>        <polyline points="8.8 4.2 8.8 7.4 11 7.4" fill="none" stroke="#1b1b1b" stroke-linecap="square" stroke-miterlimit="10" stroke-width=".8"/>      </g>  </g></svg>',
                loader: '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38 38" enable-background="new 0 0 38 38" xml:space="preserve"><g><g transform="translate(1 1)"><circle fill="none" stroke="#486966" stroke-width="2" stroke-opacity="1" cx="18" cy="18" r="18"/><path fill="none" stroke="#d9d9d9" stroke-width="2.5" d="M36,18c0-9.9-8.1-18-18-18"><animateTransform  accumulate="none" additive="replace" attributeName="transform" calcMode="linear" dur="1s" fill="remove" from="0 18 18" repeatCount="indefinite" restart="always" to="360 18 18" type="rotate"></animateTransform></path></g></g></svg>',
            },
            loading: {
                workbreak: false,
                presence: false
            },
            lastRequest: '',
            lastSuccessfull: '',
            lastChecked: '',
            lastResponse: null as any,
            lastServerUpdate: 0,
            lastServerResponse: '',
            numberPadValue: '' /* ,
            nfcUpdateEntries: [] as Array<string> */
        }
    },
    created() {
        this.activeDay = DateTimeUtils.getUnixTimestamp() //DateTimeUtils.getDayNoonTimestamp(new Date())
        this.today = this.activeDay
        this.employee = null
        this.getLocalWorkstation()
        UpdateController.setOnNfcUpdate(this.onNfcChipId)
        UpdateController.setOnUpdate(this.onUpdate)
        UpdateController.isWorkstation = true
        UpdateController.setActiveDay(DateTimeUtils.getUnixTimestamp() - 86400)
        this.lastServerUpdate = DateTimeUtils.getUnixTimestamp()
    },
    computed:{
        navigator() : string {
            return navigator.userAgent.toLowerCase();
        },
        isRasperry() : boolean {
            return navigator.userAgent.toLowerCase().includes("x11");
        },
        displayActiveDay() : string {
            return DateTimeUtils.convertTimeStampToDate(this.activeDay, true)
        },
        updateControllerActiveDay() : string {
            return this.convertTimeStampToDateAndTimeWithSeconds(UpdateController.getActiveDay())
        },
        readOnly() : boolean {
            const activeDay = (this.activeDay as number)
            const today = (this.today as number)
            return today != activeDay
        },
        presenceTime() {
            const aP = (this.activePresence as Presence)
            if (aP?.go) {
                return aP?.go - aP?.come
            } else {
                return Math.floor(new Date().valueOf() / 1000) - aP?.come
            }
        },
        showPresenceWorkbreakActions() {
            const employee = this.employee as Employee
            const workstation = this.workstation as Workstation
            return employee?.uid && !workstation?.timeentryAllowed && (workstation?.presenceAllowed || workstation?.workbreakAllowed)
        },
        showStandardActions() {
            const employee = this.employee as Employee
            const presence = this.activePresence as Presence
            const activeBreak = this.activeBreak as Workbreak
            const workstation = this.workstation as Workstation
            return employee?.uid && workstation?.timeentryAllowed && presence && !presence.go && (!activeBreak || (activeBreak?.start && activeBreak?.stop))
        },   
        showPresenceAction() {
            const employee = this.employee as Employee
            const presence = this.activePresence as Presence
            const activeBreak = this.activeBreak as Workbreak
            const workstation = this.workstation as Workstation
            return employee?.uid && workstation?.presenceAllowed && (!presence || presence?.go != 0) && (!activeBreak || (activeBreak?.start && (activeBreak?.start && activeBreak?.stop)))
        },
        showWorkbreakAction() {
            const employee = this.employee as Employee
            const presence = this.activePresence as Presence
            const activeBreak = this.activeBreak as Workbreak
            const workstation = this.workstation as Workstation
            return employee?.uid && workstation?.workbreakAllowed && presence?.come > 0 && presence?.go == 0 && activeBreak?.start != 0 && activeBreak?.stop === 0
        },
        employeeDataLoaded() {
            const presenceLoaded = this.presenceLoaded as boolean
            const breakLoaded = this.breakLoaded as boolean
            return presenceLoaded && breakLoaded
        },
        employeeIds() {
            const res = [] as number[]
            this.employees.forEach((e: Employee) => res.push(e.uid))
            return res
        },
        employeeInitials() {
            const employee = this.employee as Employee
            return employee?.firstName.substr(0,1) + employee?.lastName.substr(0,1)
        }
    },
    methods:{
            //handlers
        onNfcChipId(nfcChipId: string) {
            this.lastResponse = UpdateController.nfcResponse;
            this.lastRequest = DateTimeUtils.convertTimeStampToDateAndTimeWithSeconds(Date.now() / 1000, false) + ' (' + Date.now() + ') ' + nfcChipId
            //this.nfcUpdateEntries.push('got update response ' + DateTimeUtils.convertTimeStampToDateAndTimeWithSeconds(Date.now() / 1000, false) + nfcChipId + '\n')
            if (!this.nfcChipId && nfcChipId) {
                this.lastSuccessfull = DateTimeUtils.convertTimeStampToDateAndTimeWithSeconds(Date.now() / 1000, false) + ' (' + Date.now() + ') ' + nfcChipId
                this.resetEmployee()
                this.closeTimeouts.forEach((ts: number) => window.clearTimeout(ts))
                if (nfcChipId && nfcChipId != 'ERROR' && nfcChipId != '' && nfcChipId != this.nfcChipId) {
                    this.nfcChipId = nfcChipId
                    //this.nfcUpdateEntries.push('getWorkspace ' + DateTimeUtils.convertTimeStampToDateAndTimeWithSeconds(Date.now() / 1000, false) + ' (' + Date.now() + ') ' + nfcChipId + '\n')
                    //this.nfcUpdateEntries.push('------------------------------------------------------\n')
                    this.getWorkspace()
                }                    
                this.closeTimeouts.push(window.setTimeout(this.onTimeout, this.closeAfterSeconds*1000))
                this.addBodyEventListeners()
            }
        },   
        onUpdate(workbreaks: ObjectStorage, presences: ObjectStorage, timeentries: ObjectStorage | null) {
            this.lastServerUpdate = DateTimeUtils.getUnixTimestamp()
            /* if (!this.firstUpdateDone) {
                this.activeDay = DateTimeUtils.getUnixTimestamp()
                UpdateController.setActiveDay(DateTimeUtils.getUnixTimestamp())
                this.firstUpdateDone = true;
            } */
            this.lastServerResponse = UpdateController.getServerResponse();
            this.workBreaks = workbreaks.items.filter((br: any) => br.stop == 0)
            this.presences = presences.items
            if (this.workstation?.timeentryAllowed) {
                if (timeentries) {
                    this.workspaceTimeEntries = timeentries.items
                }   
                if (this.employee?.uid) {
                    this.timeEntries = this.workspaceTimeEntries.filter((te: TimeEntry) => te.employee.uid == this.employee?.uid)
                    this.lastTimeEntries = this.getLastTimeEntries()
                }
            }
        },
        onTestButton(code: string) {
            this.form.eCode = code
            this.onECodeChange()
        },         
        onECodeChange() {
            this.closeTimeouts.forEach((ts: number) => window.clearTimeout(ts))
            if (this.form.eCode) {
                this.resetEmployee()
                this.nfcChipId = this.form.eCode
                this.getWorkspace()
                this.closeTimeouts.push(window.setTimeout(this.onTimeout, this.closeAfterSeconds*1000))
                this.addBodyEventListeners()
            }
        },
        onTimeout() {
            this.removeBodyEventListeners()
            this.doAutomaticClose()
        },        
        onSubmitPrevent() {
            //console.log('onSubmitPrevent')
        },
        onCancelClick() {
            this.resetWorkspace()
        },
        onBodyClicked() {
            this.closeTimeouts.forEach((ts: number) => window.clearTimeout(ts))
                //call after 10 seconds
            this.closeTimeouts.push(window.setTimeout(this.onTimeout, this.closeAfterInteractionSeconds*1000))
            this.timeoutLastSet = new Date()
            //document.body.removeEventListener('click', this.onBodyClicked)
        },       
        onPresencePause(){
            if (this.activeBreak?.stop == 0) {
                this.updateBreak();
            } else {
                this.createBreak();
            }
        },         
        onToggleTimeEntry(entry: TimeEntry, startstop: string) { 
            this.toggleTimeEntry(entry, startstop)
        },        
        onNewEntry() {
            this.numberPadValue = ''
            this.showNewTimeEntry = true
        },
        onAddTimeEntryTabChange(tabIndex: number) {
            this.numberPadValue = ''
            const refElement : HTMLElement= (this.$refs.refCardTimeEntryCard as any).$el
            if (refElement) {
                const content: HTMLElement | null = refElement.querySelector('.ww-card-content')
                if (content) {
                    content.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
                }
            }
        },
        onAddTimeEntryCancel() {
            this.showNewTimeEntry = false
            this.numberPadValue = ''
        },
        onTimeEntryCreated(timeentries: ObjectStorage) {
            this.showNewTimeEntry = false
            this.numberPadValue = ''
            this.updateTimeEntries(timeentries?.items)
            this.$notify(this.$t(('success.timeEntryCreated')), { position: "right", type: "success" });
        },
        onNumberpadChange(value: any) {
            this.numberPadValue = value
        },
        onNumberpadCancel() {
            this.numberPadValue = '';
        },
            //functions
        async initWorkstation() {
            if (!this.workstation?.nfcChipReader) UpdateController.stopNfcUpdate()
            UpdateController.setUpdateTimeEntries(this.workstation ? this.workstation.timeentryAllowed : false)
            await this.getEmployees()
            await this.getActiveBreak()
            await this.getPresence()
            if (this.workstation?.timeentryAllowed) {
                this.getProjects()
                this.getClients()
                this.getWorks()
                this.getTimeEntries()
            }
        },
        resetWorkspace() {
//            console.log('resetWorkspace', this.employee)
            this.closeTimeouts.forEach((ts: number) => window.clearTimeout(ts))
            this.nfcChipId = ''
            this.numberPadValue = ''
            this.showNewTimeEntry = false
            this.actionSuccess = false
            this.actionError = false
            this.resetEmployee()
            if (this.workstation?.nfcChipReader) UpdateController.startNfcUpdate()
        },
        resetEmployee() {
            this.employee = null
            this.activePresence = null
            this.activeBreak = null
            this.timeEntries = this.timeEntries.splice(0, this.timeEntries.length)
            this.activeTimeEntry = null
            this.lastTimeEntries = this.lastTimeEntries.splice(0, this.lastTimeEntries.length)

        },
        doAutomaticClose() {
            this.resetWorkspace()
        },
        convertTimeStampToDateAndTime(ts:any) { 
            return DateTimeUtils.convertTimeStampToDateAndTime(ts, false)
        },     
        convertTimeStamp(ts:any) {            
            return DateTimeUtils.convertTimeStampToTime(ts)
        },
        convertSeconds(ts: any) {
            return DateTimeUtils.convertSecondsToTime(ts)
        },
        convertTimeStampToDateAndTimeWithSeconds(ts: any) {
            return DateTimeUtils.convertTimeStampToDateAndTimeWithSeconds(ts, false);
        },
        addBodyEventListeners() {
            document.body.addEventListener('click', this.onBodyClicked)
            document.body.addEventListener('touchstart', this.onBodyClicked)            
        },
        removeBodyEventListeners() {
            document.body.removeEventListener('click', this.onBodyClicked)
            document.body.removeEventListener('touchstart', this.onBodyClicked)
        },
        getLastTimeEntries(){
            if(this.timeEntries?.length){ 
                const sorted = this.timeEntries.sort((a : TimeEntry, b : TimeEntry) => b.start - a.start);
                const active = this.getActiveWork(sorted)
                if (active) {
                    this.activeTimeEntry = active
                    this.activeTimeTracked = DateTimeUtils.convertSecondsToTime(this.activeTimeEntry?.getTimeTracked())
                } else {
                    this.activeTimeEntry = {} as TimeEntry
                    this.activeTimeTracked = ''
                }
                return sorted
            } /* else if (this.runningEntries?.length) { 
                    //[WS 2024-04-09] no longer valid anymore?
                    const active = this.getActiveWork(this.runningEntries)
                    this.activeTimeEntry = this.runningEntries[0];
                    this.activeTimeTracked = DateTimeUtils.convertSecondsToTime(this.activeTimeEntry.getTimeTracked())
                    return this.runningEntries;
            }  */
            return []
        },
        getActiveWork(entries:Array<TimeEntry>) {
                //[WS TODO:] put this in controller or object and convert the startstops to an array
            const active = entries.find((entry : TimeEntry) => {
                let running = false;
                for (let key in entry.startstops) {
                    if (!running && entry.startstops[key].start != 0 && entry.startstops[key].stop == 0) running = true;
                }
                return running;
            });
            return active;
        },
        setDaySum() {
            this.daySum = 0
            this.lastTimeEntries.forEach((entry: TimeEntry) => {
                this.daySum += entry.getTimeGone()
            });
        },        
        updateTimeEntries(entries: any) {
                //TODO put this into controller and get the entries again from controller
            entries.forEach((entry: any) => {
                const replaceIdx = this.timeEntries.findIndex((e: any) => e.uid == entry.uid)
                if (replaceIdx != -1) {
                    //console.log('replaceIdx', replaceIdx)
                    //console.log('entry', entry)
                    this.timeEntries.splice(replaceIdx, 1, entry)
                } else {
                    this.timeEntries.push(entry)
                }
            })
            this.lastTimeEntries = this.getLastTimeEntries()
        },
        onSuccessAction() {
            this.actionSuccess = true
            this.actionError = false
            this.resetEmployee()
            this.closeTimeouts.forEach((ts: number) => window.clearTimeout(ts))
            this.closeTimeouts.push(window.setTimeout(this.onTimeout, this.closeAfterSuccess*1000))
            this.timeoutLastSet = new Date()   
        },
        onErrorAction() {
            this.actionError = true
            this.actionSuccess = false
            this.resetEmployee()
            this.closeTimeouts.forEach((ts: number) => window.clearTimeout(ts))
            //this.closeTimeouts.push(window.setTimeout(this.onTimeout, this.closeAfterSuccess*1000))
            setTimeout(() => this.actionError = false, this.resetAfterError*1000);
            this.timeoutLastSet = new Date()             
        },
            //data
        async getLocalWorkstation() {
            const workstation = await WorkstationController.getLocalWorkstation()
            if (!workstation.error) {
                this.workstation = workstation
                this.initWorkstation()
            }
        },            
        async getEmployees() {
            const res = await EmployeeController.fetchEmployees()
            if (!res.error) {
                this.employees = res.items
                const eids = [] as Array<number>
                this.employees.forEach((e: Employee) => eids.push(e.uid))
                UpdateController.employees = eids
            } else {
                this.$notify(this.$t(('error.status.' + res.status)), { position: "right", type: "error" });
            }
        },
        async getWorkspace() {
            const employee = this.employees.find((emp: Employee) => {
                return emp.getNfcChipId() == this.nfcChipId
            })
            if (employee) {
                this.employee = employee
            } else {
                    //try read the employee
                await this.getEmployee()
            }
            if (this.employee?.uid) {
                if (this.workstation?.timeentryAllowed) {
                    this.timeEntries = this.workspaceTimeEntries.filter((te: TimeEntry) => te.employee.uid == this.employee?.uid)
                    this.lastTimeEntries = this.getLastTimeEntries()
                }
                this.activePresence = this.presences.find((pr: any) => pr.employee == this.employee?.uid) as Presence
                this.activeBreak = this.workBreaks.find((br: any) => {
                    return br.employee == this.employee?.uid
                }) as Workbreak
            } else {
                this.nfcChipId = ''
            }
        },
        async getEmployee() {
            const res = await EmployeeController.getEmployeeByChip(this.nfcChipId);
            if (res.employee) {
                this.employee = res.employee;
            } else {
                this.$notify(this.$t(('error.status.' + res.status), {model: this.$t('employee.title')}), { position: "right", type: "error" });
                this.form.eCode = ''
                this.nfcChipId = ''
                this.resetWorkspace()
            }
        },
        async getPresence() {
            const res = await PresenceController.getActivePresence(this.employeeIds)
            this.presences = res.items
            this.activePresence = null
            this.presenceLoaded = true
        },     
        async getActiveBreak() {
            const breaks = await WorkbreakController.getActiveWorkbreak(this.employeeIds)
            this.workBreaks = breaks.items.filter((br: any) => br.stop == 0)
            this.activeBreak = null
            this.breakLoaded = true
        },
        async createPresence() {
            this.loading.presence = true
            this.activePresence = await PresenceController.createPresence(this.employee)
            this.presences.unshift(this.activePresence as Presence);
            this.loading.presence = false
            this.onSuccessAction()
        },
        async endPresence() {
            this.loading.presence = true
            this.activePresence = await PresenceController.endPresence(this.employee)
            this.loading.presence = false
            if (this.activePresence?.uid) {
                const idx = this.presences.findIndex((p: Presence) => p.uid == this.activePresence?.uid)
                if (idx > -1) {
                    this.presences.splice(idx, 1, this.activePresence as Presence);
                }                
                this.onSuccessAction()
            } else {
                this.onErrorAction()
            }
        },
        async getTimeEntries() {
            this.timeEntriesLoaded = false
            //const employee = (this.employee as Employee)
            const resDay = await TimeEntryController.fetchDayTimeEntries(this.employeeIds, this.activeDay)
            //console.log('getTimeEntries', resDay)
            if(!resDay.error){
                this.workspaceTimeEntries = resDay.items
            } else {
                this.$notify(this.$t(resDay.error.message), { position: "right", type: "error" })
            }
            this.lastTimeEntries = this.getLastTimeEntries()
            this.timeEntriesLoaded = true
            this.setDaySum()
        },        
        async createClonedTimeEntry(entry: TimeEntry) {
            const entries = await TimeEntryController.createTimeEntry(entry.employee.uid, entry.work.uid, entry.project.uid, entry.customer.uid, entry.startWorkstation)
            if (entries?.error) {
                this.$notify(this.$t(entries.error.data.error.message), { position: "right", type: "error" })
            } else if (entries?.items) {
                this.updateTimeEntries(entries.items)
            }            
        },        
        async toggleTimeEntry(entry: TimeEntry, startstop: string) {
            //console.log('toggleTimeEntry', entry, startstop);
            const { entries, workbreak } = await TimeEntryController.toggleTimeEntry(entry.uid, entry.employee.uid, entry.tstamp, startstop, entry.work.uid, entry.project?.uid, entry.customer?.uid, entry.startWorkstation)
            //console.log('toggleTimeEntry entries / workbreak', entries, workbreak)
            if (entries?.error) {
                if (entries.error.data.error.code == 409) {
                    this.$notify(this.$t(entries.error.data.error.message), { position: "right", type: "warning" })
                    await this.createClonedTimeEntry(entry)
                } else {
                    this.$notify(this.$t(entries.error.data.error.message), { position: "right", type: "error" })
                }
            }
            if (entries?.items) {
                this.updateTimeEntries(entries.items)
            }
            if (workbreak.uid) {
                this.activeBreak = workbreak
            }
        },        
        async createBreak() {
            this.loading.workbreak = true
            const { workbreak, timeentry } = await WorkbreakController.createWorkbreak(this.employee)
            this.loading.workbreak = false
            if (workbreak?.uid) {
                this.activeBreak = workbreak
                this.workBreaks.unshift(workbreak as Workbreak)
                this.workBreaks = this.workBreaks.filter((br: any) => br.stop == 0)
                this.onSuccessAction()
            } else {
                this.onErrorAction()
            }
            /* if (this.activeTimeEntry?.start) {
                this.toggleTimeEntry(this.activeTimeEntry, 'stop')
            } */
        },        
        async updateBreak(){
            this.loading.workbreak = true
            const tempBreak = await WorkbreakController.stopWorkbreak(this.employee)
            this.loading.workbreak = false
            if (tempBreak?.uid) {
                this.activeBreak = tempBreak
                const idx = this.workBreaks.findIndex((wb: Workbreak) => wb.uid == tempBreak.uid)
                if (idx > -1) {
                    this.workBreaks.splice(idx, 1, this.activeBreak as Workbreak);
                    this.workBreaks = this.workBreaks.filter((br: any) => br.stop == 0)
                }
                this.onSuccessAction()
            } else {
                this.onErrorAction()
            }
        },
        async getProjects() {
            this.projects = (await ProjectController.fetchProjects()).items;
        },
        async getClients(){
            const clients = await ClientController.fetchClients()
            this.clients = clients ? clients.items : []
        },
        async getWorks(){
            const works = await WorkController.fetchWorks()
            this.works = works.items ? works.items : []
        }
    }
})
